import {
  Add01Icon,
  ArrowRight02Icon,
  Button,
  ChevronDownIcon,
  ChevronUpIcon,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  MailReply02Icon,
  StarsIcon,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@porchpass/ui";
import * as React from "react";

/**
 * "Add co-borrower" split button: primary action adds a co-borrower inline,
 * the dropdown also offers inviting via email. Double-clicking the button is a
 * shortcut for "Add here". Purely presentational — actions are passed in.
 */
export function AddCoBorrowerDropdown({
  onAddHere,
  onInviteViaEmail,
  disabled,
}: {
  onAddHere: () => void | Promise<void>;
  onInviteViaEmail: () => void;
  disabled?: boolean;
}) {
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const fireAddHere = React.useCallback(() => {
    void onAddHere();
  }, [onAddHere]);

  return (
    <TooltipProvider>
      <Tooltip>
        <DropdownMenu open={dropdownOpen} onOpenChange={setDropdownOpen}>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button
                variant="secondary"
                size="s"
                onDoubleClick={fireAddHere}
                innerClassName="gap-2"
                disabled={disabled}
              >
                <Add01Icon variant="stroke-rounded" size={12} />
                Add co-borrower
                {dropdownOpen ? (
                  <ChevronUpIcon variant="stroke-standard" size={12} />
                ) : (
                  <ChevronDownIcon variant="stroke-standard" size={12} />
                )}
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent
            side="bottom"
            align="start"
            className="flex items-center gap-1 px-2.5 py-2 text-xs font-medium"
          >
            <StarsIcon size={12} className="text-white shrink-0" />
            <span>
              <span className="font-bold">Tip:</span> Double click to add here
            </span>
          </TooltipContent>
          <DropdownMenuContent align="start">
            <DropdownMenuItem onClick={fireAddHere} disabled={disabled}>
              <ArrowRight02Icon variant="stroke-standard" size={18} />
              Add here
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => {
                setDropdownOpen(false);
                onInviteViaEmail();
              }}
            >
              <MailReply02Icon variant="stroke-rounded" size={18} />
              Invite via email
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </Tooltip>
    </TooltipProvider>
  );
}
